<template>
  <transition name="snackbar">
    <div
      v-if="showSnackbar"
      class="alert alert-success alert-dismissible"
      role="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="showSnackbar = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      {{ text }}
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      showSnackbar: false,
      text: "",
      type: "success",
    };
  },
  methods: {
    toggleSnackbar(text, type) {
      this.text = text;
      this.type = type;
      this.showSnackbar = true;

      setTimeout(() => {
        this.showSnackbar = false;
      }, 1500);
    },
  },
};
</script>

<style>
.alert {
  max-width: 24rem;
  width: 100%;
  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 999;
}

.snackbar-enter-active,
.snackbar-leave-active {
  transition: opacity 0.4s, transform 0.4s;
}
.snackbar-enter,
.snackbar-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>